import { jsonp, ajax, loadScript, cookie } from '@ifeng/ui_base';
import { formatImage, formatUrl } from '@ifeng/public_method';
import { formatData } from '../utils/utils';

// apiUrl为webpack注入的全局变量
/* eslint-disable no-undef */
let apiBaseUrl = apiUrl;
const topicUrl = topicApiUrl;
/* eslint-enable no-undef */

if (typeof window === 'object' && /\.shank\.ifeng\.com/.test(window.location.hostname)) {
    apiBaseUrl = '/c';
}

const md5 = require('@ifeng/md5');

const createJsonpCallbackName = (str, num) => {
    num = num ? num : 0;
    let jsonpCallbackName = `_${md5(`${str}_${num}`)}`;

    /* eslint-disable */
    while (typeof window === 'object' && window[jsonpCallbackName]) {
        /* eslint-enable */
        num++;
        jsonpCallbackName = `_${md5(`${str}_${num}`)}`;
    }

    return jsonpCallbackName;
};

// 获取推荐内容评论数
const getRecommend = async () => {
    const result = await jsonp(`${apiBaseUrl}/api/content/graphic/recommend/getRecommend`, {
        jsonpCallback: 'getRecommend',
        cache: false,
    });

    let recommendData = [];

    if (result.data) {
        const { data, count } = result.data;

        recommendData = data.map((item, index) => ({
            id: item.id,
            title: item.title,
            url: formatUrl(item.pcUrl),
            pcUrl: item.pcUrl,
            count: count[index],
            createtime:
                item.createtime.split('-')[0] < 2018
                    ? item.createtime
                    : `${item.createtime.split('-')[1]}-${item.createtime.split('-')[2]}`,
            thumbnailpic:
                item.sourceFrom === 'video' ? formatImage(item.postUrl, 144, 80) : formatImage(item.thumbnail, 144, 80),
            source: item.sourceFrom === 'video' ? item.mediaName : item.source,
            sourceFrom: item.sourceFrom,
        }));
    }

    return recommendData;
};

// 获取文章评论数
const getCommentCount = async url => {
    const { schemaCheck } = await import('./validate');

    let data = await jsonp('//comment.ifeng.com/get/count', {
        data: {
            format: 'js',
            docurl: url,
        },
        jsonpCallback: 'getCommentCount',
        cache: false,
    });
    const requestUrl = `comment.ifeng.com/get/count?format=js&docurl=${url}&callback=getCommentCount`;

    data = schemaCheck(data, 'commentCountSchema', requestUrl);

    return data ? data : null;
};

// 获取轮播图数据
const getSlidesData = async attachmentId => {
    const callback = createJsonpCallbackName('getSlidesData');

    const data = await jsonp(`${apiBaseUrl}/api/content/graphic/getSlides/${attachmentId}/${callback}`, {
        jsonpCallback: callback,
        cache: false,
    });

    let slidesData = null;

    if (data.data) {
        slidesData = {
            url: data.data.url,
            slideData: JSON.parse(data.data.slideData).image,
        };
    }

    return slidesData;
};

// 获取文章推荐数
const getVoteNum = async url => {
    const { schemaCheck } = await import('./validate');

    let data = await jsonp('//survey.news.ifeng.com/api/getaccumulatorweight', {
        data: {
            format: 'js',
            key: url,
            serviceid: 2,
        },
        jsonpCallback: 'getaccumulator',
        cache: false,
    });
    const requestUrl = `//survey.news.ifeng.com/api/getaccumulatorweight?format=js&key=${url}&callback=getaccumulator`;

    data = schemaCheck(data.data, 'voteNumSchema', requestUrl);

    return data ? data : null;
};

// 文章推荐操作
const vote = async url => {
    const data = await jsonp('//survey.news.ifeng.com/api/accumulator', {
        data: {
            format: 'js',
            key: url,
        },
        jsonpCallback: 'accumulator',
        cache: false,
    });

    return data.code === 1;
};

// 获取热门文章数据
const getArticle = async () => {
    const data = await ajax('/c/api/content/graphic/article');

    let articleData = [];

    if (data.data) {
        articleData = data.data.slice(0, 10).map(item => ({
            url: formatUrl(item.url),
            title: item.title,
            img: item.img === '' ? '' : formatImage(item.img, 100, 56),
        }));
    }

    return articleData;
};

// 获取精彩视频数据
const getVideo = async () => {
    const data = await jsonp(`${apiBaseUrl}/api/content/graphic/video/getVideo`, {
        jsonpCallback: 'getVideo',
        cache: false,
    });

    let videoData = [];

    if (data.data) {
        videoData = data.data.slice(0, 10).map(item => ({
            url: formatUrl(item.url),
            title: item.title,
            img: item.img === '' ? '' : formatImage(item.img, 100, 56),
        }));
    }

    return videoData;
};

// 获取凤凰无线数据
const getWirelessData = async () => {
    const data = await jsonp(`${apiBaseUrl}/api/content/graphic/wireless/getWirelessData`, {
        jsonpCallback: 'getWirelessData',
        cache: false,
    });

    let result = [];

    if (data.code === 0 && data.data && data.data instanceof Array) {
        result = data.data.slice(0, 2);

        for (const item of result) {
            item.image_url = formatImage(item.image_url, 140, 80);
            item.link_url = formatUrl(item.link_url);
        }
    }

    return result;
};

// 获取调查数据
const getSurveyData = async id => {
    const { schemaCheck } = await import('./validate');

    let data = await jsonp('//sv.ifeng.com/index.php/survey/getdata', {
        data: {
            id,
        },
        jsonpCallback: 'getSurveyData',
        cache: false,
    });
    const requestUrl = `sv.ifeng.com/index.php/survey/getdata?id=${id}&callback=getSurveyData`;

    data = schemaCheck(data, 'surveyDataSchema', requestUrl);

    return data ? data : null;
};

// 提交调查数据
const postSurveyData = async (param, id) => {
    return await jsonp(`//sv.ifeng.com/index.php/survey/postsurvey?${param}`, {
        data: {
            id,
            act: 'postsurvey',
            surid: id,
            ref: 'http://finance.ifeng.com/survey.html',
        },
        jsonpCallback: 'postSurveyData',
        cache: false,
    });
};

// 幻灯 根据频道获取推荐图集
const getRecommandSlides = async (searchPath, base62Id) => {
    const num = 15;
    let recommandData = [];
    const searchPathArr = [];

    searchPath
        .slice(0, searchPath.length - 1)
        .split('-')
        .forEach((item, index) => {
            if (searchPathArr.length === 0) {
                searchPathArr.push(`${item}-`);
            } else {
                searchPathArr.push(`${searchPathArr[index - 1]}${item}-`);
            }
        });

    // 数据不足时，先从跟栏目取数据
    for (let i = searchPathArr.length; i--; i === 0) {
        const data = await jsonp(`${apiBaseUrl}/api/slide/${searchPathArr[i]}/getRecommandSlides`, {
            jsonpCallback: 'getRecommandSlides',
            cache: false,
        });

        if (data.code === 0 && data.data && data.data.length > 0) {
            let slidesArr = [];
            const slides = data.data.filter(item => item.base62Id !== base62Id);

            // 数据去重
            for (const item of slides) {
                const base62Id = item.base62Id;

                let flag = 0;

                for (const slide of recommandData) {
                    if (slide.base62Id === base62Id) {
                        flag = 1;
                    }
                }

                if (flag === 0) {
                    slidesArr.push(item);
                }
            }

            slidesArr = slidesArr.slice(0, num - recommandData.length).map(item => ({
                base62Id: item.base62Id,
                url: item.url ? item.url : '',
                thumbnail:
                    item.thumbnails && item.thumbnails.image && item.thumbnails.image.length > 0
                        ? formatImage(item.thumbnails.image[0].url, 180, 122)
                        : '',
                title: item.title ? item.title : '',
            }));

            recommandData = recommandData.concat(slidesArr);
        }

        console.log(recommandData);

        if (recommandData.length === num) {
            return recommandData;
        }
    }

    // 数据再不足时，再跟全站幻灯动态碎片取数据
    if (recommandData.length < num) {
        const data = await jsonp(`${apiBaseUrl}/api/client/topnewslist/getTopnewslist`, {
            jsonpCallback: 'getTopnewslist',
            cache: false,
        });

        if (data.code === 0 && data.data && data.data.length > 0) {
            let listArr = [];

            const list = data.data.filter(
                item => item.status === '1' && item.type === 'slide' && item.base62Id !== base62Id,
            );

            // 数据去重
            for (const item of list) {
                const base62Id = item.base62Id;

                let flag = 0;

                for (const slide of [...recommandData]) {
                    if (slide.base62Id === base62Id) {
                        flag = 1;
                    }
                }

                if (flag === 0) {
                    listArr.push(item);
                }
            }

            listArr = listArr.slice(0, num - recommandData.length).map(item => ({
                url: item.url ? item.url : '',
                thumbnail:
                    item.thumbnails && item.thumbnails.image && item.thumbnails.image.length > 0
                        ? formatImage(item.thumbnails.image[0].url, 180, 122)
                        : '',
                title: item.title ? item.title : '',
            }));

            console.log(listArr);

            recommandData = recommandData.concat(listArr);
        }
    }

    return recommandData;
};

// 幻灯 获取最后一帧图集推荐
const getPicRecom = async channel => {
    const { schemaCheck } = await import('./validate');

    let data = await jsonp(`${apiBaseUrl}/api/content/graphic/slide/${channel}/callback`, {
        jsonpCallback: 'callback',
        cache: false,
    });
    const requestUrl = `${apiBaseUrl}/api/3/graphic/slide/${channel}`;

    data = schemaCheck(data.data, 'picRecomSchema', requestUrl);

    let picRecom = null;

    if (data) {
        picRecom = data.map(item => ({
            url: item.url,
            title: item.title,
            img: item.img ? formatImage(item.img, 171, 103) : '',
            publishTime: item.publishTime,
        }));
    }

    return picRecom;
};

// 原创 获取栏目往期文章
const getSection = async (base62Id, searchPath) => {
    const data = await jsonp(`${apiBaseUrl}/api/content/original/getSection/${searchPath}/callback`, {
        jsonpCallback: 'callback',
        cache: false,
    });

    let list = data.data.filter(item => item.base62Id !== base62Id);

    list = list.slice(0, 10).map(item => ({
        url: formatUrl(item.url),
        title: item.title,
    }));

    return list;
};

// 获取分享二维码
const getQrCode = async url => {
    return await jsonp(`//qrcode.ifeng.com/qrcode.php?url=${url}?_share=weixin`, {
        jsonpCallback: 'getQrCode',
        cache: false,
    });
};

// 幻灯统计
// const requestUrl = (datatype, value) => {
//     let re_url = '//stadig.ifeng.com/actsta.js?';
//     const fa_param = window.getFaParams();
//     let r = [];
//     const pt = encodeURIComponent('hdtype=high');
//     const url = encodeURIComponent(window.location.href);
//     const time = new Date().getTime();

//     r.push(`datatype=${datatype}`);
//     r.push(`value=${value ? value : ''}`);
//     r.push(`uri=${url}`);
//     r.push('ref=');
//     r.push(`uid=${fa_param.uid ? fa_param.uid : ''}`);
//     r.push(`sid=${fa_param.sid ? fa_param.sid : ''}`);
//     r.push(`time=${time}`);
//     r.push(`ci=${fa_param.ci ? fa_param.ci : ''}`);
//     if (datatype === 'share') {
//         r.push(`pt=${pt ? pt : ''}`);
//     }
//     r = r.join('&');
//     re_url += r;
// };

const requestTongji = async (datatype, value) => {
    const fa_param = window.getFaParams();
    const url = window.location.href;
    const time = new Date().getTime();
    const pt = 'hdtype=high';

    try {
        await loadScript('//stadig.ifeng.com/actsta.js', {
            data: {
                datatype,
                value: value ? value : '',
                uri: url,
                ref: '',
                uid: fa_param.uid ? decodeURIComponent(fa_param.uid) : '',
                sid: fa_param.sid ? decodeURIComponent(fa_param.sid) : '',
                time,
                ci: fa_param.ci ? decodeURIComponent(fa_param.ci) : '',
                pt: datatype === 'share' ? pt : '',
            },
            cache: false,
        });
    } catch (e) {
        console.error(e);
    }
};

// 批量获取文章评论数
const getCommentCounts = async docUrl => {
    let data = [];

    try {
        data = await jsonp('//comment.ifeng.com/get/multicount', {
            data: {
                doc_url: docUrl.join('|'),
                format: 'js',
                callback: 'getCommentCounts',
            },
            jsonpCallback: 'getCommentCounts',
            cache: false,
        });
    } catch (e) {
        console.error(e);
    }

    return data;
};

// 批量获取点赞数
const getVoteNums = async url => {
    // const { schemaCheck } = await import('./validate');

    let apiUrl = '//survey.news.ifeng.com/api/getaccumulatorweight?';

    // 接口拼接
    if (url.length > 0) {
        url.forEach(item => {
            apiUrl += `key[]=${item}ding&`;
        });
    }

    let data = await jsonp(apiUrl, {
        data: {
            format: 'js',
            serviceid: 2,
        },
        jsonCallback: 'getaccumulator',
        cache: false,
    });
    // const requestUrl = `//survey.news.ifeng.com/api/getaccumulatorweight?format=js&key=${vid}&callback=getaccumulator`;

    // data = schemaCheck(data.data, 'voteNumSchema', requestUrl);
    data = data.data;

    return data ? data : null;
};

/**
 * 获取自媒体账号详情接口
 * @param {Number} cid 自媒体账号id
 * @returns {Object} accountDetail,自媒体账户信息
 */
const getwemediaEAccountInfo = async cid => {
    const accountDetail = await jsonp(`${apiBaseUrl}/api/getwemediaEAccountInfo/${cid}/getwemediaEAccountInfo`, {
        jsonpCallback: 'getwemediaEAccountInfo',
        cache: 120,
    });

    return accountDetail.data;
};

/**
 * 大风号获取自媒体账号详情接口
 * @param {Number} cid 自媒体账号id
 * @returns {Object} accountDetail,自媒体账户信息
 */
const getFengAccountDetail = async cid => {
    const accountDetail = await jsonp(
        `${apiBaseUrl}/api/content/feng/articlePage/getFengAuthorInfo/${cid}/getFengAccountDetail`,
        {
            jsonpCallback: 'getFengAccountDetail',
            cache: 120,
        },
    );

    if (accountDetail.code === 0 && accountDetail.data && accountDetail.data.success) {
        return accountDetail.data;
    }

    return accountDetail.data;
};

/**
 * 获取大风号账户文章或视频列表数据
 * @param {String} id 自媒体账号ID
 * @param {String} type 类型
 * @param {Number} page 页码
 * @returns {Array} 返回数组
 */
const getFengListData = async id => {
    const listData = await jsonp(
        `${apiBaseUrl}/api/content/feng/articlePage/getFengAuthorListData/${id}/getFengAuthorListData`,
        {
            jsonpCallback: 'getFengAuthorListData',
            cache: 120,
        },
    );

    return listData;
};

// 获取文章评论数
const getFengCommentCount = async url => {
    return await jsonp('//comment.ifeng.com/get.php', {
        data: {
            job: 4,
            format: 'js',
            callback: 'getAllComment1',
            docurl: url.join('|'),
        },
        jsonCallback: 'getAllComment1',
        cache: false,
    });
};

// 获取视频播放数
const getVideoComment = async vid => {
    // const { schemaCheck } = await import('./validate');

    let apiUrl = '//survey.news.ifeng.com/api/getaccumulatorweight?';

    // 接口拼接
    if (vid.length > 0) {
        vid.forEach(item => {
            apiUrl += `key[]=${item}&`;
        });
    }

    let data = await jsonp(apiUrl, {
        data: {
            format: 'js',
            serviceid: 1,
        },
        jsonCallback: 'getVideoComment1',
        cache: false,
    });
    // const requestUrl = `//survey.news.ifeng.com/api/getaccumulatorweight?format=js&key=${vid}&callback=getaccumulator`;

    // data = schemaCheck(data.data, 'voteNumSchema', requestUrl);
    data = data.data;

    return data ? data : null;
};

const randomId = num => {
    let returnStr = '';
    const charStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

    for (let i = 0; i < num; i++) {
        const index = Math.round(Math.random() * (charStr.length - 1));

        returnStr += charStr.substring(index, index + 1);
    }

    return returnStr;
};

const getVideoRecomlist = async (guid, title) => {
    try {
        const data = await jsonp(
            `${apiBaseUrl}/api/videoRecom/getRecomlist/${guid}/${encodeURIComponent(title)}/getVideoRecomlist1`,
            {
                jsonpCallback: 'getVideoRecomlist1',
                cache: false,
            },
        );

        return data ? data : null;
    } catch (e) {
        console.error(e);
    }
};

/**
 * 获取专题预览数据
 * @param {String} id 专题ID
 * @param {String} cookieInfo 权限cookie
 * @returns {Object} 返回数组
 */
const getTopicPreviewData = async (id, cookieInfo) => {
    try {
        const callback = createJsonpCallbackName(`getTopicPreviewData_${Math.random()}`);

        const data = await jsonp(
            `${topicUrl}/client/content/topic/getTopicPreviewData/${id}/${cookieInfo}/${callback}`,
            {
                jsonpCallback: callback,
                cache: false,
            },
        );

        let topic = {};

        if (data.data) {
            const val = data.data;

            val.ad = JSON.parse(val.ad);

            val.modules.sort((a, b) => {
                return a.sequence > b.sequence ? 1 : -1;
            });

            let moduleIndex = 1;

            val.modules = val.modules.map(item => {
                const data = formatData(item.data);

                if (item.display === 1 && data.length > 0) {
                    if (item.type !== 'column' && item.type !== 'slide') {
                        item['moduleIndex'] = moduleIndex++;
                    } else if (item.type === 'column') {
                        data.forEach(element => {
                            element['moduleIndex'] = moduleIndex++;
                        });
                    }
                }

                return { ...item, data };
            });

            topic = {
                ...data.data,
                modules: val.modules,
            };
        }

        return topic;
    } catch (e) {
        console.error(e);
    }

    return {};
};

// 获取自媒体账号的视频列表
const getWemediaVideoList = async id => {
    try {
        return await jsonp(`${apiBaseUrl}/api/video/getWeMediaListData/${id}/getWemediaVideoList1`, {
            jsonpCallback: 'getWemediaVideoList1',
            cache: false,
        });
    } catch (e) {
        console.error(e);
    }
};

export {
    getRecommend,
    getCommentCount,
    getSlidesData,
    getVoteNum,
    vote,
    getArticle,
    getVideo,
    getWirelessData,
    getSurveyData,
    postSurveyData,
    getRecommandSlides,
    getPicRecom,
    getSection,
    getQrCode,
    requestTongji,
    getCommentCounts,
    getVoteNums,
    getwemediaEAccountInfo,
    getFengAccountDetail,
    getFengListData,
    getFengCommentCount,
    getVideoComment,
    getVideoRecomlist,
    getTopicPreviewData,
    getWemediaVideoList,
};
